import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Target, GraduationCap, ClipboardCheck, Wallet,
  Boxes, FileCheck, BookOpenText, Award, Briefcase, MessageSquareText,
  SlidersHorizontal, Users, Building2, UserCog, LogOut,
  Activity, Clock, MonitorPlay, UserCheck, FileBarChart2,
  CalendarClock, Receipt, AlertCircle,
  CalendarDays, BookOpen, ClipboardList, SquareCheckBig,
  ClipboardPen, BarChart3, FolderTree, Building, Handshake,
  Star, MessageSquareQuote, ListChecks, GitMerge, DoorOpen, CalendarCheck,
  UserRound, UserRoundX, BadgeInfo, Network, MapPin, KeyRound, Grid2x2, BadgeCheck,
  ShieldCheck, ShieldEllipsis, KeySquare, UsersRound,
  ChevronRight,
} from "lucide-react";
import Swal from "sweetalert2";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import { canAccessOrganizationList } from "../../Utils/organizationPermissions";

/* ── Section label map ───────────────────────── */
const SECTION_BEFORE = {
  Dashboard:           "Overview",
  Leads:               "Engagement",
  Fees:                "Operations",
  Certificates:        "Outcomes",
  "Employee Management": "Administration",
  "Organization Setup":  "Configuration",
};

/* ── Sidebar nav options ─────────────────────── */
const BASE_OPTIONS = [
  {
    heading: "Dashboard",
    title: "Dashboard",
    route: "/",
    icon: <LayoutDashboard size={19} strokeWidth={2} />,
  },
  {
    heading: "Leads",
    title: "Leads",
    icon: <Target size={19} strokeWidth={2} />,
    children: [
      { route: "/leads",                        title: "Leads",                  icon: <UsersRound size={16} strokeWidth={2} />,     PermissionKey: "VIEW_LEADS" },
      { route: "/lead-activities",              title: "Lead Activities",        icon: <Activity size={16} strokeWidth={2} />,      PermissionKey: "VIEW_LEAD_ACTIVITY" },
      { route: "/lead-contact-timings",         title: "Lead Contact Timings",   icon: <Clock size={16} strokeWidth={2} />,         PermissionKey: "VIEW_LEAD_CONTACT_TIMINGS" },
      { route: "/demo-sessions",                title: "Demo Sessions",          icon: <MonitorPlay size={16} strokeWidth={2} />,   PermissionKey: "VIEW_DEMO_SESSIONS" },
      { route: "/demo-participants",            title: "Demo Participants",      icon: <UserCheck size={16} strokeWidth={2} />,     PermissionKey: "VIEW_DEMO_PARTICIPANTS" },
      { route: "/leads-monthly-funnel-report",  title: "Lead Monthly Report",    icon: <FileBarChart2 size={16} strokeWidth={2} />, PermissionKey: "LEAD_MONTHLY_REPORT" },
    ],
  },
  {
    heading: "Students",
    title: "Students",
    route: "/students",
    icon: <GraduationCap size={19} strokeWidth={2} />,
    PermissionKey: "VIEW_STUDENTS",
  },
  {
    heading: "Admissions",
    title: "Admissions",
    route: "/admissions",
    icon: <ClipboardCheck size={19} strokeWidth={2} />,
    PermissionKey: "VIEW_ADMISSIONS",
  },
  {
    heading: "Fees",
    title: "Fees",
    icon: <Wallet size={19} strokeWidth={2} />,
    children: [
      { route: "/fee-installments", title: "Fee Installments", icon: <CalendarClock size={16} strokeWidth={2} />, PermissionKey: "VIEW_FEE_INSTALLMENTS" },
      { route: "/students-fees",    title: "Fee Receipts",     icon: <Receipt size={16} strokeWidth={2} />,       PermissionKey: "VIEW_STUDENT_FEE" },
      { route: "/fee-due-report",   title: "Fee Due",          icon: <AlertCircle size={16} strokeWidth={2} />,   PermissionKey: "FEE_DUE_REPORT" },
    ],
  },
  {
    heading: "Batches",
    title: "Batches",
    icon: <Boxes size={19} strokeWidth={2} />,
    children: [
      { route: "/batches",                  title: "Batches",                  icon: <Boxes size={16} strokeWidth={2} />,        PermissionKey: "VIEW_BATCHES" },
      { route: "/student-batch-calendar",   title: "Student Batch Calendar",   icon: <CalendarDays size={16} strokeWidth={2} />, PermissionKey: "VIEW_BATCHES" },
      { route: "/batch-students",           title: "Batch Students",           icon: <Users size={16} strokeWidth={2} />,        PermissionKey: "VIEW_BATCH_STUDENTS" },
      { route: "/batch-classes",            title: "Batch Classes",            icon: <BookOpen size={16} strokeWidth={2} />,     PermissionKey: "VIEW_BATCH_CLASS" },
      { route: "/class-records",            title: "Batch Class Records",      icon: <ClipboardList size={16} strokeWidth={2} />,PermissionKey: "VIEW_BATCH_CLASS_RECORD" },
      { route: "/classes-attendance",       title: "Attendance",               icon: <SquareCheckBig size={16} strokeWidth={2} />, PermissionKey: "VIEW_CLASS_ATTENDANCES" },
    ],
  },
  {
    heading: "Assesments",
    title: "Assessments",
    icon: <FileCheck size={19} strokeWidth={2} />,
    children: [
      { route: "/assesments",        title: "Assessments",       icon: <ClipboardPen size={16} strokeWidth={2} />,  PermissionKey: "VIEW_ASSESSMENTS" },
      { route: "/assesment-results", title: "Assessment Results", icon: <BarChart3 size={16} strokeWidth={2} />,    PermissionKey: "VIEW_ASSESSMENT_RESULTS" },
    ],
  },
  {
    heading: "Trainings",
    title: "Trainings",
    icon: <BookOpenText size={19} strokeWidth={2} />,
    children: [
      { route: "/training-programs",           title: "Training Programs",            icon: <BookOpen size={16} strokeWidth={2} />,   PermissionKey: "VIEW_TRAINING_PROGRAMS" },
      { route: "/training-programs-categories", title: "Training Program Categories",  icon: <FolderTree size={16} strokeWidth={2} />, PermissionKey: "VIEW_TRAINING_PROGRAM_CATEGORIES" },
    ],
  },
  {
    heading: "Certificates",
    title: "Certificates",
    route: "/certificates",
    icon: <Award size={19} strokeWidth={2} />,
    PermissionKey: "VIEW_CERTIFICATES",
  },
  {
    heading: "Placements",
    title: "Placements",
    icon: <Briefcase size={19} strokeWidth={2} />,
    children: [
      { route: "/recruitment-agencies",  title: "Recruitment Agencies",   icon: <Building2 size={16} strokeWidth={2} />,  PermissionKey: "VIEW_RECRUITMENT_AGENCIES" },
      { route: "/companies",             title: "Companies",               icon: <Building size={16} strokeWidth={2} />,   PermissionKey: "VIEW_COMPANIES" },
      { route: "/placement-referrals",   title: "Placement Referrals",     icon: <Handshake size={16} strokeWidth={2} />,  PermissionKey: "VIEW_PLACEMENT_REFERRALS" },
    ],
  },
  {
    heading: "Reviews",
    title: "Reviews",
    icon: <MessageSquareText size={19} strokeWidth={2} />,
    children: [
      { route: "/student-review-platforms", title: "Review Platforms",  icon: <Star size={16} strokeWidth={2} />,              PermissionKey: "VIEW_REVIEW_PLATFORM" },
      { route: "/student-reviews",  title: "Student Reviews",   icon: <MessageSquareQuote size={16} strokeWidth={2} />, PermissionKey: "VIEW_STUDENT_REVIEW" },
    ],
  },
  {
    heading: "Setup",
    title: "Setup",
    icon: <SlidersHorizontal size={19} strokeWidth={2} />,
    children: [
      { route: "/lead-stages",                 title: "Lead Stages",                   icon: <ListChecks size={16} strokeWidth={2} />,  PermissionKey: "VIEW_LEAD_STAGE" },
      { route: "/lead-sources",                title: "Lead Sources",                  icon: <GitMerge size={16} strokeWidth={2} />,    PermissionKey: "VIEW_LEAD_SOURCE" },
      { route: "/training-spaces",             title: "Training Spaces",               icon: <DoorOpen size={16} strokeWidth={2} />,    PermissionKey: "VIEW_TRAINING_SPACES" },
      { route: "/slot-availability",           title: "Slot Availability",             icon: <CalendarCheck size={16} strokeWidth={2} />, PermissionKey: "VIEW_SLOT_AVALABILITY" },
      { route: "/trainer-slot-availability",   title: "Trainer Slot Availability",     icon: <CalendarClock size={16} strokeWidth={2} />, PermissionKey: "VIEW_TRAINER_SLOT_AVALABILITY" },
    ],
  },
  {
    heading: "Employee Management",
    title: "Employee Management",
    icon: <Users size={19} strokeWidth={2} />,
    children: [
      { route: "/organization/employee/employee-details", title: "Employees",       icon: <UserRound size={16} strokeWidth={2} />,  PermissionKey: "EMPLOYEE_VIEW_ALL" },
      { route: "/organization/employee/employee-exits",   title: "Employee Exits",  icon: <UserRoundX size={16} strokeWidth={2} />, PermissionKey: "EMPLOYEE_EXIT_VIEW_ALL" },
    ],
  },
  {
    heading: "Organization Setup",
    title: "Organization Setup",
    icon: <Building2 size={19} strokeWidth={2} />,
    children: [
      { route: "/organization/details",          title: "Organizations",          icon: <Building2 size={16} strokeWidth={2} />, PermissionKey: "ORGANIZATION_ALL" },
      { route: "/organization/profile",          title: "Organization Profile",   icon: <BadgeInfo size={16} strokeWidth={2} />,   PermissionKey: "ORGANIZATION_PROFILE_ALL" },
      { route: "/organization/entity",           title: "Organization Entities",  icon: <Network size={16} strokeWidth={2} />,   PermissionKey: "ENTITY_ALL" },
      { route: "/organization/location",         title: "Locations",              icon: <MapPin size={16} strokeWidth={2} />,    PermissionKey: "LOCATION_ALL" },
      { route: "/organization/application-access", title: "Application Access",  icon: <KeyRound size={16} strokeWidth={2} />,  PermissionKey: "VIEW_ORGANIZATION_APPLICATION" },
      { route: "/organization/departments",      title: "Departments",            icon: <Grid2x2 size={16} strokeWidth={2} />,   PermissionKey: "DEPARTMENT_ALL" },
      { route: "/organization/designation",      title: "Designations",           icon: <BadgeCheck size={16} strokeWidth={2} />, PermissionKey: "DESIGNATION_ALL" },
      { route: "/organization/work-shift",       title: "Workshifts",             icon: <CalendarClock size={16} strokeWidth={2} />, PermissionKey: "SHIFT_VIEW_ALL" },
    ],
  },
  {
    heading: "User management",
    title: "User management",
    icon: <UserCog size={19} strokeWidth={2} />,
    children: [
      { route: "/users",                           title: "Users",                      icon: <UserRound size={16} strokeWidth={2} />,     PermissionKey: "USER_VIEW_ALL" },
      { route: "/application/user-roles",          title: "User Roles",               icon: <ShieldCheck size={16} strokeWidth={2} />,   PermissionKey: "USER_ROLE_ALL" },
      { route: "/application/user-role-permission", title: "User Role Permissions",   icon: <ShieldEllipsis size={16} strokeWidth={2} />, PermissionKey: "USER_ROLE_PERMISSION_ALL" },
      { route: "/application/user-permission",     title: "User Permission Overrides", icon: <KeySquare size={16} strokeWidth={2} />,    PermissionKey: "USER_PERMISSION_ALL" },
    ],
  },
];

/* ── Animated collapse ───────────────────────── */
function NavChildren({ open, children }) {
  const ref = useRef(null);
  const [h, setH] = useState(open ? "auto" : 0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open) {
      const target = el.scrollHeight;
      setH(target);
      const t = setTimeout(() => setH("auto"), 230);
      return () => clearTimeout(t);
    } else {
      setH(el.scrollHeight);
      requestAnimationFrame(() => requestAnimationFrame(() => setH(0)));
    }
  }, [open]);
  return (
    <div
      className="ems-nav-children"
      ref={ref}
      style={{ height: h === "auto" ? "auto" : h + "px" }}
    >
      <div style={{ paddingBottom: 4 }}>{children}</div>
    </div>
  );
}

/* ── SideBar ─────────────────────────────────── */
export default function SideBar({ Permission, collapsed }) {
  const { logout, userData } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebaroption, setSideBarOption] = useState(BASE_OPTIONS);
  const [openGroups, setOpenGroups] = useState(() => {
    const o = {};
    BASE_OPTIONS.forEach((item) => {
      if (item.children && item.children.some((c) => c.route === location.pathname)) {
        o[item.heading] = true;
      }
    });
    return o;
  });

  const hasPermission = (action) => {
    if (!Permission || !Array.isArray(Permission) || !action) return false;
    return Permission.some((p) => String(p).toUpperCase() === String(action).toUpperCase());
  };

  useEffect(() => {
    if (!Permission || !Array.isArray(Permission)) {
      setSideBarOption(BASE_OPTIONS);
      return;
    }
    const filtered = BASE_OPTIONS.map((item) => {
      if (item.children) {
        const allowedChildren = item.children.filter((child) => {
          if (child.route === "/demo-sessions")
            return hasPermission("VIEW_DEMO_SESSIONS") || hasPermission("VIEW_SELF_DEMO_SESSIONS");
          if (child.route === "/demo-participants")
            return hasPermission("VIEW_DEMO_PARTICIPANTS") || hasPermission("VIEW_SELF_DEMO_PARTICIPANTS");
          if (child.route === "/batches" || child.route === "/student-batch-calendar")
            return hasPermission("VIEW_BATCHES") || hasPermission("VIEW_SELF_BATCHES");
          if (child.route === "/batch-students")
            return hasPermission("VIEW_BATCH_STUDENTS") || hasPermission("VIEW_SELF_BATCH_STUDENTS");
          if (child.route === "/batch-classes")
            return hasPermission("VIEW_BATCH_CLASS") || hasPermission("VIEW_SELF_BATCH_CLASSES");
          if (child.route === "/class-records")
            return hasPermission("VIEW_BATCH_CLASS_RECORD") || hasPermission("VIEW_SELF_BATCH_CLASS_RECORDS");
          if (child.route === "/classes-attendance")
            return hasPermission("VIEW_CLASS_ATTENDANCES") || hasPermission("VIEW_SELF_CLASS_ATTENDANCE");
          if (child.route === "/organization/details" || child.route === "/organization/switcher")
            return canAccessOrganizationList(Permission);
          return child.PermissionKey ? hasPermission(child.PermissionKey) : true;
        });
        if (allowedChildren.length === 0) return null;
        return { ...item, children: allowedChildren };
      }
      if (item.PermissionKey) return hasPermission(item.PermissionKey) ? item : null;
      return item;
    }).filter(Boolean);
    setSideBarOption(filtered);
  }, [Permission]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2f3645",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("token");
          await axios.get(`${MAIN_URL}/api/auth/logout`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          logout();
          localStorage.removeItem("token");
          navigate("/login");
        } catch {
          logout();
          navigate("/login");
        }
      }
    });
  };

  const handleNav = (route) => navigate(route);

  const toggleGroup = (heading) =>
    setOpenGroups((o) => ({ ...o, [heading]: !o[heading] }));

  let seenLabels = new Set();

  return (
    <>
      <div className="ems-sidebar-scroll">
        {sidebaroption.map((item, index) => {
          const sectionLabel = SECTION_BEFORE[item.heading];
          const showLabel = sectionLabel && !seenLabels.has(sectionLabel);
          if (showLabel) seenLabels.add(sectionLabel);

          const isActive = !item.children && item.route === location.pathname;
          const childActive = item.children && item.children.some((c) => c.route === location.pathname);
          const isOpen = !!openGroups[item.heading];

          return (
            <React.Fragment key={item.heading || index}>
              {showLabel && (
                <div className="ems-nav-section-label">{sectionLabel}</div>
              )}
              {item.children ? (
                <>
                  <button
                    className={[
                      "ems-nav-item",
                      childActive ? "parent-active" : "",
                    ].filter(Boolean).join(" ")}
                    onClick={() => toggleGroup(item.heading)}
                    title={collapsed ? item.title : undefined}
                  >
                    <span className="ems-ni-icon">{item.icon}</span>
                    <span className="ems-ni-label">{item.title}</span>
                    <span className={`ems-ni-chev${isOpen ? " open" : ""}`}>
                      <ChevronRight size={16} strokeWidth={2.4} />
                    </span>
                  </button>
                  {!collapsed && (
                    <NavChildren open={isOpen}>
                      {item.children.map((child) => (
                        <button
                          key={child.route}
                          className={[
                            "ems-nav-child",
                            location.pathname === child.route ? "active" : "",
                          ].filter(Boolean).join(" ")}
                          onClick={() => handleNav(child.route)}
                        >
                          <span className="ems-nc-icon">{child.icon}</span>
                          <span className="ems-nc-label">{child.title}</span>
                        </button>
                      ))}
                    </NavChildren>
                  )}
                </>
              ) : (
                <button
                  className={[
                    "ems-nav-item",
                    isActive ? "active" : "",
                  ].filter(Boolean).join(" ")}
                  onClick={() => handleNav(item.route)}
                  title={collapsed ? item.title : undefined}
                >
                  <span className="ems-ni-icon">{item.icon}</span>
                  <span className="ems-ni-label">{item.title}</span>
                </button>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="ems-sidebar-foot">
        <button
          className="ems-nav-item"
          onClick={handleLogout}
          title={collapsed ? "Logout" : undefined}
        >
          <span className="ems-ni-icon">
            <LogOut size={19} strokeWidth={2} />
          </span>
          <span className="ems-ni-label">Logout</span>
        </button>
      </div>
    </>
  );
}
